import { AppDestroy, provideAppDestroy } from '@bcf-vanilla-ts-v1-shared/di/app-destroy';
import { PageScrollerService, pageScrollerService } from '@tmf-shared-platform/page-scroller/page-scroller.service';
import { isServer } from 'lit';
import { auditTime, fromEvent, takeUntil } from 'rxjs';

export class RouterPageScrollerService {
  constructor(
    private _pageScrollerService: PageScrollerService,
    private _appDestroy: AppDestroy
  ) {}

  public init(): void {
    if (isServer) {
      return;
    }
    fromEvent(window, 'routerUpdated')
      .pipe(auditTime(100), takeUntil(this._appDestroy.destroy$))
      .subscribe(() => this._pageScrollerService.scrollTop());
  }
}

export const routerPageScrollerService: RouterPageScrollerService = new RouterPageScrollerService(
  pageScrollerService,
  provideAppDestroy()
);
